import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router5";
import { PersistGate } from "redux-persist/integration/react";

import "./index.css";
import App from "./main/App";
import reportWebVitals from "./reportWebVitals";
import createRouter from "./router/create-router";

import { store, persistor } from "./redux/store";
import { fetchCurrentUser } from "./redux/user/userSlice";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { subscribe, ensureSubscribeAndUpdate } from "./sw/sw_subscribe";

store
  .dispatch(fetchCurrentUser())
  .then((p) => {
    if (p.payload.user) {
      startRouter("postfeed");
    } else {
      startRouter("login");
    }
  })
  .catch(() => {
    startRouter("login");
  });

function startRouter(default_route) {
  const router = createRouter(default_route);

  router.start((err, state) => {
    ReactDOM.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <RouterProvider router={router}>
            <React.StrictMode>
              <App />
            </React.StrictMode>
          </RouterProvider>
        </PersistGate>
      </Provider>,
      document.getElementById("root"),
    );
  });
}

// each time the app load try to subscribe
ensureSubscribeAndUpdate().catch((res) => {
  if (res && res.error) {
    console.log("[sw subscribe error] " + res.error);
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register()
serviceWorkerRegistration.register({
  onSuccess: subscribe,
  onUpdate: () => {},
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
